<button nz-button nzType="default" style="margin-bottom: 20px;" (click)="showModal()">
    <nz-icon nzType="upload" />
   Add file
</button>

<nz-table #basicTable [nzData]="fileList" [nzBordered]="false" [nzSize]="'small'" [nzShowPagination]="false">
    <thead>
      <tr>

        <th>Name</th>
        <th>Type</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr  *ngFor="let item of fileList; trackBy: trackById">
       
          <td><p nzFlex  style="padding-top: 10px;">  
            <nz-avatar nzShape="square" nzIcon="file" 
                [nzSrc]="item.file"></nz-avatar>
              
           <span style="margin-left: 10px;">  {{ item?.name  | titlecase }} </span>   </p> </td>
          <td> {{ item?.type }}</td>
           
          <td>
            <button nz-button nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit Contact" nzTooltipPlacement="top" (click)="downloadFile(item)" class="action-button">
               <i nz-icon nzType="download"></i>  
            </button>
             
            <button nz-button  class="action-button"
            nzDanger  nzShape="circle" nzSize="small"
            nz-popconfirm 
            nzPopconfirmTitle="Delete this file?"
            nzPlacement="top"
            (nzOnConfirm)="removeFile(item)"
           >
          <i nz-icon nzType="delete"></i>
         </button>
          </td>
       
      </tr>
    </tbody>
  </nz-table>

<!-- <nz-list [nzDataSource]="fileList" [nzBordered]="true" [nzLoading]="loading">
    <nz-list-item *ngFor="let item of fileList; trackBy: trackById">
        
        <nz-list-item-meta>
            <nz-list-item-meta-title>
               <p nzFlex  style="padding-top: 10px;">  <nz-avatar nzShape="square" nzIcon="file" 
                [nzSrc]="item.file"></nz-avatar> <span style="margin-left: 10px;">  {{ item?.name  | titlecase }} </span>   </p>   
            </nz-list-item-meta-title>
            
        </nz-list-item-meta>
        <div>
           
             <nz-tag>
                    {{ item?.type }}
             </nz-tag>
            
            <button nz-button nzType="primary" (click)="downloadFile(item)">
                <i nz-icon nzType="download"></i>  
            </button>
            <nz-divider nzType="vertical"></nz-divider>
            <button nz-button 
            nzDanger 
            nz-popconfirm 
            nzPopconfirmTitle="Delete this file?"
            nzPlacement="top"
            (nzOnConfirm)="removeFile(item)"
           >
          <i nz-icon nzType="delete"></i>
         </button>
        </div>
    </nz-list-item>
</nz-list> -->

<nz-modal [(nzVisible)]="isVisible" nzTitle="Upload a new file" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <form [formGroup]="projectForm" nz-form nzLayout="horizontal" *nzModalContent>
        <!-- Upload Contract -->
    <nz-form-item>
        <nz-form-label [nzSpan]="7" >Upload Contract</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select a file">
          <nz-upload  class="w-100" [nzSize]="5242880"
           [nzCustomRequest]="customUploadRequest"
            nzListType="picture" [nzBeforeUpload]="beforeUpload"
            (nzChange)="onUploadContractChange($event)"
            [(nzFileList)]="scfileList">
            <button nz-button>
              <i nz-icon nzType="paper-clip"></i> Attach Files
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
  
      <!-- Additional Files -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" >Additional Files</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select a file">
          <nz-upload  class="w-100" [nzSize]="5242880"
           [nzCustomRequest]="customUploadRequest"
            nzListType="picture" [nzBeforeUpload]="beforeUpload"
            (nzChange)="onUploadAdditionalChange($event)"
            [(nzFileList)]="fileListAdd">
            <button nz-button>
              <i nz-icon nzType="paper-clip"></i> Attach Files
            </button>
          </nz-upload>
        </nz-form-control>
      </nz-form-item>
    
    </form>
  </nz-modal>